import {useTransition} from '@logistics-frontend/blocks'
import type {ServerError} from '@logistics-frontend/core/utils/network'
import type {PaymentInfoModel} from '@yandex-delivery/api/model/order'
import {useController, useFormContext} from '@yandex-delivery/form'
import {memo} from 'react'

import {fetchPaymentInfo} from 'src/shared/api'
import {appConfig} from 'src/shared/config'

type Props = {
  name: string
}

export const PaymentInfoControl = memo<Props>(function PaymentInfoControl({name}) {
  const {control} = useFormContext()
  const {field} = useController({control, name})

  // todo 🤔 вероятно тут поход в бекенд и не нужен,
  //      потому что во внешней форме заказа кроме карты больше не может быть способов оплаты
  useTransition<PaymentInfoModel, ServerError>(
    () =>
      fetchPaymentInfo(appConfig.countryCode)
        .then(response => {
          field.onChange(response)
          return response
        })
        .catch(error => {
          field.onChange(undefined)
          throw error
        }),
    {key: `fetch/payment-info/${name}`},
  )

  return null
})
